"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponentThemes = require("../../_nextgen/packages/styled-component-themes/");
var _Text = _interopRequireDefault(require("../../components/Text"));
var _analytics = _interopRequireWildcard(require("../../components/analytics"));
var _IconLibrary = require("../../packages/IconLibrary");
var _index = _interopRequireDefault(require("./index.styled"));
var colors = _interopRequireWildcard(require("./index.themes"));
var _jsxRuntime = require("react/jsx-runtime");
const Icons = {
  Plus: _IconLibrary.Plus,
  Minus: _IconLibrary.Minus
};
const Drawer = function (_ref) {
  let {
    label = "MORE",
    labelClose,
    labelColor,
    iconColor,
    children,
    startOpen = false,
    type = "",
    id,
    className,
    expandedIcon = "Minus",
    collapsedIcon = "Plus",
    showDecorator = false
  } = _ref;
  const hashOpen = window.location.hash === `#${id}`;
  const [showDropdown, updateDropdown] = _react.default.useState(startOpen || hashOpen);
  const accordionBodyRef = _react.default.useRef(null);
  const fireAnalytics = (0, _analytics.default)("Drawer", {});
  _react.default.useEffect(function () {
    window.addEventListener("closeDrawer", function () {
      updateDropdown(false);
      fireAnalytics("closeDrawer");
    });
  }, []);
  const handleButtonClick = function () {
    const dropdownShown = !showDropdown;
    updateDropdown(dropdownShown);
    if (dropdownShown && accordionBodyRef.current) {
      fireAnalytics("openDrawer");
      accordionBodyRef.current.scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    } else {
      fireAnalytics("closeDrawer");
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.DrawerAccordion, {
    id: id ? id : undefined,
    className: className,
    $showDecorator: showDecorator && showDropdown,
    "data-testid": "Drawer",
    children: [type === "accordion" ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.AccordionTitle, {
      onClick: handleButtonClick,
      ref: accordionBodyRef,
      $active: showDropdown,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.AccordionTitleText, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          children: labelClose ? showDropdown ? labelClose : label : label
        })
      }), showDropdown ? /*#__PURE__*/(0, _react.createElement)(Icons[expandedIcon], {
        "aria-hidden": "true"
      }) : /*#__PURE__*/(0, _react.createElement)(Icons[collapsedIcon], {
        "aria-hidden": "true"
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.AccordionButton, {
      type: "button",
      $showDropdown: showDropdown,
      onClick: handleButtonClick,
      color: iconColor,
      ref: accordionBodyRef,
      "aria-expanded": showDropdown,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.DrawerHeading, {
        $color: labelColor,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          children: label
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Arrow, {
        "aria-hidden": "true",
        $showDropdown: showDropdown,
        $color: iconColor
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.AccordionContent, {
      $show: showDropdown,
      tabIndex: showDropdown ? 0 : 1,
      "aria-hidden": !showDropdown,
      children: children
    })]
  });
};
var _default = exports.default = (0, _analytics.withAnalytics)((0, _styledComponentThemes.withThemes)(Drawer, colors))({});